import { useEffect, useState } from 'react';

//import CanvasJSReact from '../../assets/canvasjs.react';
//@ts-ignore
import CanvasJSReact from '@canvasjs/react-charts'

import { DateTime, Info } from 'luxon';
import { convertTimezone } from '../../lib/utils';
import { useAppStore } from '../../stores/RootStore';
import { CanvasMarker } from '../../types/types';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJSReact.CanvasJS.addCultureInfo("ru",
  {
    days: Info.weekdays("long"),
    shortDays: Info.weekdays("short"),
    months: Info.months("long"),
    shortMonths: Info.months("short")
});

interface BaseChartProps {
  type: string,
  title: string,
  data: ChartData[], 
  selectedDate: {
    from: Date,
    to: Date
  },
  dates: {
    from: string,
    to: string
  },
  onChangeDates: Function;
  loading: boolean;
  markers?: CanvasMarker[]
}

interface ChartData {
    at: number,
    v: number
}

interface Data {x: Date, y: number | null}



const BaseChartInReport = ({ data, selectedDate, dates, type, title, onChangeDates, loading, markers }:BaseChartProps) => {
  const {currentSite} = useAppStore()
  const [defaultPeriod, setDefaultPeriod] = useState(true);
  const [currentIntervalType, setCurrentIntervalType] = useState<string>('minutes')
  const [zoomed, setZoomed] = useState(false)
  const [reset, setReset] = useState(false)
  const [chartData, setChartData] = useState<Data[]>([]);

  useEffect(() => {
    if (!data) {
      return;
    }
    const itemData: Data[] = [];
      data.forEach(it => {
        itemData.push({
          x: new Date(it.at + convertTimezone(it.at)),
          y: it.v ? (it.v > 0 ? it.v : 0) : null  
        })
      });
    setChartData(itemData);
  }, [data]);

  const calculateIntervalType = (min: number, max: number) => {
    const interval = Math.floor(max / 1000) - Math.floor(min / 1000);
    if (interval <= 3600) {
      return 'minutes';
    }
    if (interval > 3600 && interval <= 172800) {
      return 'hours';
    }
    if (interval > 172800 && interval <= 2678400) {
      return 'days';
    }
    if (interval > 2678400) {
      return 'month';
    }
  };

  useEffect(() => {
    if(!dates.to) { return }
    setCurrentIntervalType(calculateIntervalType(new Date(dates.from).getTime(), new Date(dates.to).getTime())!)
  },[dates])


  const rangeChanged = (
    attr: { trigger: string; axisX: { viewportMaximum: any; viewportMinimum: any }[]; }, 
    ) => {
      
    if (attr.trigger === 'reset') {
      onChangeDates(
        {
          from: selectedDate.from,
          to: selectedDate.to
        }
      )
    } else {
      setDefaultPeriod(false);
      const min = attr.axisX[0].viewportMinimum;
      const max = attr.axisX[0].viewportMaximum;

      onChangeDates(
        {
          from: DateTime.fromMillis(Math.round(min) - convertTimezone(Math.round(min))).toUTC().toJSDate(),
          to: DateTime.fromMillis(Math.round(max) - convertTimezone(Math.round(max))).toUTC().toJSDate()
        }
      )
    }
  };

  const baseOptions = {
    animationEnabled: true,
    zoomEnabled: true,
    height: 140,
    backgroundColor: "transparent",
    culture: DateTime.local().locale,
    toolbar: {
      itemBackgroundColor: "rgba(172,172,179,0.5)",
      itemBackgroundColorOnHover: "#eccaa0",
      buttonBorderColor: "#eccaa0",
      buttonBorderThickness: 2,
      fontColor: "#d6d6d6",
      fontColorOnHover: "#d3d3d3"
    },
    toolTip : {
      contentFormatter: function ( e: { entries: { dataPoint: { x: Date, y: string; }; }[]; } ) {
        let seconds = e.entries[0].dataPoint.x.getTime() / 1000
        let date = DateTime.fromSeconds(seconds - convertTimezone(seconds) / 1000)
        return date.toFormat("HH:mm:ss") + ": " + e.entries[0].dataPoint.y;  
      } 
    },
    axisX:{
      lineColor: 'rgba(172,172,179,0.5)',
      intervalType: currentIntervalType,
      valueFormatString: currentIntervalType === 'minutes' ? 'HH:mm:ss' : currentIntervalType === 'hours' ? 'HH:mm' : currentIntervalType === 'days' ? 'DD MMM' : 'MMM YYYY',
      tickLength: 20,
      tickColor: 'transparent',
      labelFontColor: '#596890',
      labelFontSize: 10,
      labelFontFamily: 'helvetica',
      labelAutoFit: true,
      margin: 10,
      stripLines: markers?.map(marker => ({
        value: marker.at,
        label: marker.type === "start" ? "Начало работы" : "Конец работы",
        labelFontColor: "#808080",
        labelAlign: "near"
      }))
    },
    axisY: {
      includeZero: true,
      lineColor: 'transparent',
      margin: 0,
      gridDashType: 'dash',
      gridColor: 'rgba(172,172,179,0.5)',
      tickLength: 8,
      tickColor: 'transparent',
      labelPlacement: "inside",
      tickPlacement: "inside",
      labelFontColor: '#596890',
      labelFontSize: 10,
      labelFontFamily: 'helvetica',
      labelMaxWidth: 100,
    },
    rangeChanged: rangeChanged
  };

  const options = {
    data: [{
      xValueFormatString: "HH:mm:ss",
      type: "splineArea",
      connectNullData: false,
      // type: "area",
      color: type === 'network' ? '#7FBB8F' : '#009FB7',
      fillOpacity: .7,
      lineColor: type === 'network' ? '#7FBB8F' : '#009FB7',
      lineThickness: 1,
      markerType: "circle",
      markerSize: 0,
      dataPoints: chartData
    }]
  };

  return ( 
    <div className="flex flex-col space-y-2">
      <CanvasJSChart options = {{...baseOptions, ...options}}/>
    </div>
     
  )
};

export default BaseChartInReport;